/*
 * @描叙: 异步加载路由集合 
 * @作者: hanlaifu 
 * @公司: 春梅信息 
 * @创建时间: 2019-03-08 10:34:36 
*/

import ArchivesMana from './ArchivesMana'    // 档案管理路由
import SystemMana from './SystemMana'    // 系统设置路由
import EquipmentMana from './EquipmentMana'  // 设备管理路由
import ChargeMana from './ChargeMana'    // 收费管理路由
import StatementMana from './StatementMana'  // 报表管理路由
import MeterControlMana from './MeterControlMana'    // 抄控管理路由
import UserCenter from './UserCenter'    // 个人中心路由
import TerminalControl from './TerminalControl'  //  末端控制路由

const routeList = [
    {
        path: '/',
        component: resolve => require(['@/views/Layout/Index'], resolve),
        title: "layout",
        children: [
            // 档案管理
            ...ArchivesMana,
            // 设备管理
            ...EquipmentMana,
            // 收费管理
            ...ChargeMana,
            // 报表管理
            ...StatementMana,
            // 系统设置
            ...SystemMana,
            // 抄控管理
            ...MeterControlMana,
            // 个人中心
            ...UserCenter,
            // 末端控制
            ...TerminalControl,
        ],
    },
]

export default routeList